import React, { useState,useEffect,useRef  } from 'react';
import { Route, Router,Routes, BrowserRouter, Navigate } from 'react-router-dom';

import Lang from './components/lang/translations';

import AuthService from "./userServices/authServices";
import { GoogleOAuthProvider } from '@react-oauth/google';

import helpers from "./components/_helpers/helpersFunction";

import ReactGA from 'react-ga4';
import { GTMEvents } from './components/_helpers/gtm/gtm';

import NavbarDesktop from './components/navbar_desktop';
import MenuMobileTop from './components/menu/menu_mobile_top.js';

import MenuMobileBottom from './components/menu/menu_mobile_bottom.js';

import ChatContent from './components/chat/chat_content';
import ChatList from './components/chat/chats';

import Notifications from './components/chat/notifiche_e_like.js';

import Angel from './components/angel/angel.js';
import Find from './components/find/find.js';
import Footer from './components/footer';

import Tooltip from './components/warnings/tooltips';



import Context from './components/context/context';
import LocationChange from './components/locationChange/locationChange';
import ContactUs from './components/contactUs/contactUs.js';
import CatchAll from './components/catchAll/catchAll';

import {ErrorBoundary} from 'react-error-boundary'

import Legal from './components/legal/legal';

import PopupInfo from './components/popup/popupInfo';
import PopupNotifica from './components/popup/popupNotifica';
import PopupHook from './components/popup/popupHook';
import PopupGenerico from './components/popup/popupGenerico';


import Profilo from './components/profilo/profilo';

import PushTelegram from './components/pushTelegram/pushTelegram';

import Match from './components/match/MatchPage.js';

import PianiAbbonamento from './components/payment/pianiAbbonamento';
import Ok from './components/payment/ok';
import Ok_trustPay from './components/payment/forms/trustPay/payment_check.js';
import Ko from './components/payment/ko';
import PaymentPage from './components/payment/paymentPage';

import Unsubscribe from './components/unsubscribe/unsubscribe.js';

import Check_payment_adyen from './components/payment/forms/adyen/payment_check.js';
import Check_payment_maxpay from './components/payment/forms/maxpay/payment_check.js';
import Check_payment_googlePay from './components/payment/forms/adyen_google_pay/payment_check.js';
import Check_payment_mollie from './components/payment/forms/mollie/payment_check.js';
import Check_payment_coda from './components/payment/forms/coda/payment_check.js';
import Finalize_payment_shift4 from './components/payment/forms/shift4/finalize_payment.js';

import helpersFunction from './components/_helpers/helpersFunction';

import {Socket} from './components/socket/socket';

import PopupFotoProfilo from './components/popup/popupFoto.js';




const config = require("./components/_helpers/configServizi");





//7402360047854125
//4024007118468684 insuff fund 12/22 - 111
/*
4012000100000007 - success
4024007134364842 - incorrect cvc
4024007118468684 - insufficent funds
4024007114621187 - lost/stolen
4916018475814056 - other reason

06/2022 - 111
*/

export default function App() {
	
	
	const [modalShow, setModalShow] = useState(false);
	const [modalShowHook, setModalShowHook] = useState(false);
	const [modalShowPopupGenerico, setModalShowPopupGenerico] = useState(false);
	const [popupHook, setPopupHook] = useState({});
	const [popupGenerico, setPopupGenerico] = useState({});
	const [notificaAngel, setNotificaAngel] = useState({"time":5,"msg":"prima notifica","type":"Default","da":"dc3edce30abc11e9a6c5101f74370270"});
	const [waitNotifiche, setWaitNotifiche] = useState(0);
	const [messaggiNonLetti, SetMessaggiNonLetti] = useState(1);
	const [country, SetCountry] = useState(helpers.getCountry());
	const [showPopupFoto, setShowPopupFoto] = useState(false);
	const firstUpdate = useRef(true);

	var token =localStorage.getItem("token");
	

	const domain = window.location.hostname;


	
	//WEBSOCKET
	const [nuovoMessaggio, setNuovoMessaggio] = useState({});
		
	var time = new Date();

	const notificaCalled = useRef(false);

	
	const [verifiedUser, setVerifiedUser] = useState(false); //utente già noto/loggato/già registrato
	const [premiumLevel, setPremiumLevel] = useState(0);
	const [fluxId, setFluxId] = useState(helpersFunction.setFluxIdInitial());
	const [paymentPageText, setPaymentPageText] = useState({header1:"pagamento_sicuro",header2:"dati_protetti",text1:""});
	const [tooltip, setTooltip] = useState({visible:false,title:"Title1",text:"Testo1"});
	const [creditiMessaggi, setCreditiMessaggi] = useState(0);
	const [creditiIcebreaker, setCreditiIcebreaker] = useState(0);
	const [pageOkEnabled, setPageOkEnabled] = useState(false);
	const [customerId, setCustomerId] = useState(false);
	const [searchRegion, setSearchRegion] = useState(null);
	const [searchCity, setSearchCity] = useState(null);
	const [tipoHomeForm, setTipoHomeForm] = useState("registrazione");
	const [flusso, setFlusso] = useState({}); //flusso di pagamento ed hook completo
	const [valoreMessaggio, setValoreMessaggio] = useState(10);
	const [statoSignupForm, setStatoSignupForm] = useState(false); //stato chiamata verified()
	const [rateplanScelto, setRateplanScelto] = useState({});
	const [actonfile, setActonfile] = useState(false);
	const [newCard, setNewCard] = useState(false);
	const [headerAbbonamento, setHeaderAbbonamento] = useState({});
	const [city, setCity] = useState("");
	const [email, setUserEmail] = useState("");
	const [stepFormSignup, setStepFormSignup] = useState(1);
	const [ccare_session, setCcare_session] = useState(false);
	const [aff_payment_url, setAff_payment_url] = useState({});
	const [cookiePolicy, setCookiePolicy] = useState(localStorage.getItem("cookiePolicy"));
	const [profiliLike, setProfiliLike] = useState([]);
	const [navigation, setNavigation] = useState({});
	const [user_info, setUser_info] = useState({});
	const [messaggioPending, setMessaggioPending] = useState({});
	const [seme, setSeme] = useState(helpersFunction.set_seme());
	
	var browserInactive = null
	
	const contextValue = {
		navigation,
		setNavigation,
		verifiedUser,
		setVerifiedUser,
		modalShow, 
		setModalShow,
		setModalShowHook,
		setPopupHook,
		popupHook,
		messaggiNonLetti,
		SetMessaggiNonLetti,
		fluxId,
		setFluxId,
		paymentPageText,
		setPaymentPageText,
		tooltip,
		setTooltip,
		creditiMessaggi,
		setCreditiMessaggi,
		creditiIcebreaker,
		setCreditiIcebreaker,
		premiumLevel,
		setPremiumLevel,
		pageOkEnabled,
		setPageOkEnabled,
		customerId,
		setCustomerId,
		searchRegion,
		setSearchRegion,
		statoSignupForm,
		setStatoSignupForm,
		tipoHomeForm,
		setTipoHomeForm,
		flusso,
		setFlusso,
		valoreMessaggio,
		setValoreMessaggio,
		rateplanScelto,
		setRateplanScelto,
		actonfile,
		setActonfile,
		newCard,
		setNewCard,
		headerAbbonamento,
		setHeaderAbbonamento,
		city,
		setCity,
		stepFormSignup,
		setStepFormSignup,
		setPopupGenerico,
		popupGenerico,
		setModalShowPopupGenerico,
		nuovoMessaggio,
		setNuovoMessaggio,
		ccare_session,
		setCcare_session,
		cookiePolicy,
		setCookiePolicy,
		processoDiNotifica,
		aff_payment_url,
		setAff_payment_url,
		email,
		setUserEmail,
		setSearchCity,
		searchCity,
		Socket,
		profiliLike,
		setProfiliLike,
		user_info,
		setUser_info,
		messaggioPending,
		setMessaggioPending,
		seme,
		setSeme
	  };
	
	
	function isUserInAnyChat() {
		return window.location.pathname.startsWith("/chats");
	}

	function isUserInCurrentChat(angelId) {
		const currentPath = window.location.pathname;
		const chatPath = "/chats/" + angelId;
		// Rimuoviamo slash finali per il confronto
		const normalizedCurrent = currentPath.replace(/\/$/, "");
		const normalizedChat = chatPath.replace(/\/$/, "");
		return normalizedCurrent === normalizedChat;
	}
		
	function processoDiNotifica(){
		const start = async () => {
			console.log("Start notifiche")
			await waitForNotification(notificaAngel);
		}
		start()
		notificaCalled.current = true;
	}




	
	async function waitForNotification(notifica){
		//console.log("wait for notification",notifica,new Date())
		var timeout = notifica.msg == "prima notifica" ? 40000 : 10000
		if(window.location.hostname == "localhost"){
			timeout = 10000
		}
		let promise = new Promise((res, rej) => {
			var intervalID = setInterval(() => {
				if (new Date() > new Date(notifica.time)) {
					res(intervalID);
				}
			}, timeout);
		});
		
		let intervalID = await promise;
		
		clearInterval(intervalID);

			
		/* ----- CHIEDO UNA NUOVA NOTIFICA ---- */
		if( notifica.type != "full"){
			console.log("Chiediamo nuova notifica al brain",notifica)
			if(notifica.type === "wait_socket"){
				return true
			}

			getNotification()
		}
		
		/* ----- VISUALIZZO LA NOTIFICA ---- */
		if(notifica.type !== "wait_socket"){
			if(notifica.type !== "Default"){
				
				if(notifica.type !== "full"){
					SetMessaggiNonLetti(messaggiNonLetti + 1)
					localStorage.setItem('messaggiNonLetti',messaggiNonLetti)
					setNuovoMessaggio(notifica);
					if (!isUserInAnyChat()) {
						setModalShow(true);
					}
				}
			}
		}
		return true
	}
	


	useEffect(() => { 
		if(verifiedUser){
			processoDiNotifica()
		}
	},[notificaAngel]);


	/*--------------------------------------------------*/
		
	async function getNotification(tipologia){

		// DEBUG
		


		const browserSyntax = helpersFunction.getBrowserVisibility()
		
		if (document[browserSyntax.hidden]) {
			localStorage.setItem("notificheInPending","true");
			localStorage.setItem("tipologiaNotifica",tipologia);
			
			return
		}

		const trackerId = localStorage.getItem("trackerId");
		const token =localStorage.getItem("token");
		const parameters = {
			trackerId:trackerId,
			tipologia:tipologia,
			country:country,
			domain:window.location.hostname,
			landedTime: localStorage.getItem("landedTime"),
			fluxid:fluxId,
			premiumLevel:premiumLevel,
			region:searchRegion,
			provenienza_richiesta:"online",
			use_ai:flusso.use_ai,
			servizio:window.location.hostname
		}
		
		//console.log("PARAMETRI RICHIESTA NOTIFICA",parameters)

		Socket.emit('brain', parameters);

		/* --------- Richiesta al BRAIN con FETCH ----------- */
		
		/*

		const headers = {
			'Accept': 'application/json, text/plain, ',
			'Content-Type': 'application/json',
			'Authorization': 'Bearer '+ token
			}

		fetch(process.env.REACT_APP_BRAIN+"/brain",{ 
			method: 'post', 
			headers: headers,
			body: JSON.stringify(parameters)
		})
		.then(response => response.json())
		.then(risposta => {
			setNotificaAngel(risposta);
			
		}) 
		.catch((error) => {
			console.error(error);
		});			
		*/
	}


	function ErrorFallback({error, resetErrorBoundary}) {
		//window.location.reload()
		helpersFunction.logToBackend("E R R O R BOUNDARY",{err:error}) 
	}


	  const myErrorHandler = (error, info) => {
		const errore = {
			error:error,
			info:info
		}
		helpersFunction.logToBackend("E R R O R",{err:errore,clickid:localStorage.getItem("trackerId")})
	  }
	




	useEffect(() => {



		window.addEventListener('error', function(e) {
			console.log(e.error,e.message,e.filename)
			helpersFunction.logToBackend("E R R O R",{error:e.error,err:e.message,line:e.lineno,source:e.source,clickid:localStorage.getItem("trackerId"),page:window.location})
		
		})

		const browserSyntax = helpersFunction.getBrowserVisibility()
		window.addEventListener(browserSyntax.visibilityChange, function(){
			
			if (!document[browserSyntax.hidden]) {
				//----- browser visibile
				const currentTime = new Date()
				let timeDifference = currentTime - browserInactive; 
			
				if(timeDifference > 180000){ //3 minuti
					//console.log("Ricarico pagina per inattività prolungata",timeDifference)
					window.location.reload()
				} 

				var tipoNotifica = localStorage.getItem("tipologiaNotifica")
				var notificheInPending = localStorage.getItem("notificheInPending")
				
				if(notificheInPending == "true"){
					
					localStorage.setItem("notificheInPending","false");
					
					getNotification(tipoNotifica);
				}
			}else{
				//BROWSER INATTIVO
				browserInactive = new Date()
			}
			
		}, false);
	
		if(token){
			
			AuthService.verify(token)
				.then(user => {
					
					
					
						helpersFunction.setAnalyticsDimensions(user.clickid,user.source,user.country,user.fluxId,true)
						helpersFunction.setExternalScripts()

						//uso il modulo popupFotoProfilo per mostrare il popup foto profilo

						if(user.error){
							if (user.message === "disabled_user") {
								helpersFunction.showPopuphook("utente_disabilitato",contextValue,user)
								setVerifiedUser(false)
								return
							}
							
							if(user.message === "redirect"){
								window.location.href = user.redirect
								return
							}
						}
						
						if(user.verify == false){
							//+++ Utente conosciuto in precedenza. Faccio una nuova signup
							helpers.resettoUser()
							helpers.InitialSetup(contextValue)
							setModalShowHook(true)
							setVerifiedUser(false)
						}else{

							if(user.token){
								localStorage.setItem('token',user.token)
							}

							//------ blocco utente in caso DOI che non ha confermato mail
							if(user.flusso.optin === "doi" && user.confirmed_email === false){
								
								setUserEmail(user.email)
								helpersFunction.showPopuphook("doi",contextValue,user)

								setVerifiedUser(true) 

								
								//qui è falso perchè deve andare in catchall sulla doiConfirm.js
								//MODIFICA 25/08: lo rimetto su true perchè altrimenti le external offer vanno in homepage
								setModalShowHook(true)
								return
							}


							

							//------ blocco utente in caso login with google che non ha confermato regione
							if(!user.region || user.region == ""){
								helpersFunction.showPopuphook("impostaRegione",contextValue,user)
								setVerifiedUser(false)
								return
							}

							
							if(user.regalo_messaggi){
								// --- devo inserire un setTimeout perchè appena setVerifiedUser(true) nella setUser() il popup scompare (???!!!)
								setTimeout(()=>{
									var contenuto = {}
									contenuto.title = Lang( {"w": "bentornato","page": "popupGenerico","var":true} )
									contenuto.descrizione = Lang( {"w": "regalo_messaggi","page": "popupGenerico","var":true} )
									contenuto.bottoni = [
										{testo:Lang( {"w": "chiudi","page": "popupGenerico","var":true}),icona:"fa fa-window-close","var":true }
									]
									console.log(contenuto)
									helpersFunction.showPopupgenerico("regalo_messaggi",contextValue,contenuto)
								},500)
							} 
							
							//console.log("UTENTE VERIFICATO",user.foto_obbligatoria)
							if(user.foto_obbligatoria){
								setShowPopupFoto(true);
							}

							// Controlla se deve mostrare un popup dopo 2 minuti
							/*
								setTimeout(() => {
									helpersFunction.showPopupgenerico("scelta_canale_notifiche", contextValue, user)
								}, 300) // 2 minuti = 120000 millisecondi
							*/
							
								
							helpers.setUser(user,contextValue,true,true).then(()=>{})
							helpers.GetNavigation(user.clickid,contextValue)
								
								
							
						}
					
				})
		}else{
			
			helpers.InitialSetup(contextValue);
			helpersFunction.setExternalScripts()
			setModalShowHook(true);
		}

		helpersFunction.getBrowserFingerprint();
		
		
		
		firstUpdate.current = false;

		

	},[]);


	


	useEffect(() => {

		if(verifiedUser){

			helpersFunction.checkLandedTime();

			Socket.emit('clickid', { clickid:localStorage.getItem("trackerId") })

			const oldSocketRemovedHandler = async function (data) {
				console.log("SETTO SOCKET ATTUALE")
				localStorage.setItem("socketId",Socket.id)
			}

			const chatHandler = (messaggio) => {
				//ReactGA.event({	category: 'User',action: 'Messaggio ricevuto'})
				if (messaggio.type === "full" ) {
					return
				}

				if (messaggio.ritardo) {

				
					setTimeout(() => {
						if (messaggio.type != "wait_ai") {
							setNuovoMessaggio(messaggio);
							setModalShow(true);
							getNotification()
						}
					}, messaggio.offset)
				} else {



					if (messaggio.type != "wait_ai") {
						setNuovoMessaggio(messaggio);
						setModalShow(true);
						helpers.kpiPanel(contextValue, "receive_reply", null, null, null, { canon: "receive_reply", dedup: true, meta: { chat_id: messaggio.angelId } });
					}

					if (messaggio.type == "wait_ai") {
						setTimeout(() => {
							getNotification()
						}, messaggio.offset)
					}

					return 
				}
			}

			const creditiResiduiHandler = (messaggio) => {
				
				setCreditiIcebreaker(messaggio.creditiIcebreaker)
				setCreditiMessaggi(messaggio.creditiTotali)
			}

			const pausePressingHandler = (info) => {
				//bufferWarningPressing.push(info.msg.angelId)
			}

			const restartHandler = () => {
				console.log("RICEVUTO RESTART DAL SERVER, RICARICO LA PAGINA")
				window.location.reload()
			}

			const softwareVersionHandler = (data) => {
				localStorage.setItem("softwareVersion",data.softwareVersion)
				if(data.reload){
					console.log("RICEVUTO UPDATE VERSION DAL SERVER, RICARICO LA PAGINA")
					window.location.reload()
				}
			}

			const connectErrorHandler = (err) => {
				const trackerId = localStorage.getItem("trackerId")
				Socket.emit('clickid', { clickid:localStorage.getItem("trackerId") })
				//helpersFunction.logToBackend("PROBLEMA SOCKET",{err:err,clickid:trackerId})
			}

			Socket.on('oldSocketRemoved', oldSocketRemovedHandler)
			Socket.on('chat', chatHandler)
			Socket.on('creditiResidui', creditiResiduiHandler)
			Socket.on('pausePressing', pausePressingHandler)
			Socket.on('restart', restartHandler)
			Socket.on('softwareVersion', softwareVersionHandler)
			Socket.on("connect_error", connectErrorHandler)

			return () => {
				Socket.off('oldSocketRemoved', oldSocketRemovedHandler)
				Socket.off('chat', chatHandler)
				Socket.off('creditiResidui', creditiResiduiHandler)
				Socket.off('pausePressing', pausePressingHandler)
				Socket.off('restart', restartHandler)
				Socket.off('softwareVersion', softwareVersionHandler)
				Socket.off('connect_error', connectErrorHandler)
			}

		}


	},[verifiedUser,Socket]);


	return (
		<ErrorBoundary FallbackComponent={ErrorFallback} onError={myErrorHandler}>
			<BrowserRouter>
			<GoogleOAuthProvider clientId="509492564268-puot4o2st0u13n2hm9bhtip3soddg4l6.apps.googleusercontent.com">
				<Context.Provider value={contextValue}>
					<div data-theme={config.servizi[domain].tema}>
						<LocationChange/>
						<PopupNotifica
							show={modalShow}
							onHide={() => {setModalShow(false)}}
							notifica={nuovoMessaggio}
							data-theme={config.servizi[domain].tema}
						/> 

						{showPopupFoto && (
						<PopupFotoProfilo
							onClose={() => setShowPopupFoto(false)}
							
						/>)}

						{modalShowHook && (
							<PopupHook
								show={modalShowHook}
								backdrop="static"
								keyboard={false}
								onHide={() => {setModalShowHook(false);setPopupHook({ ...popupHook, provenienza:null}); } }
								contenuto={popupHook.contenuto}
								provenienza={popupHook.provenienza}
								angel={popupHook.angel}
								data-theme={config.servizi[domain].tema}
							/> 
						)}
						
						{modalShowPopupGenerico && (
							<PopupGenerico
								show={modalShowPopupGenerico}
								onHide={() => {setModalShowPopupGenerico(false);}}
								provenienza={popupGenerico.provenienza}
								contenuto={popupGenerico.contenuto}
								data-theme={config.servizi[domain].tema}
							/>
						)}
					
						
						
							{verifiedUser && (
							<React.Fragment>
								<NavbarDesktop crediti={creditiMessaggi} nonLetti={messaggiNonLetti}/>
								
								{/*<button style={{position:"absolute",width:"200px",top:"40px",left:"40px",zIndex:"999999"}} onClick={() => {getNotification()}} >PIGIAMI</button>*/}
								
								<MenuMobileTop crediti={creditiMessaggi}/>
								<MenuMobileBottom crediti={creditiMessaggi}/>
								<Tooltip/>
								
									<Routes>
										<Route path="/chats/:u" element={<ChatContent nuovo={nuovoMessaggio} verifiedUser={verifiedUser}/> }/>
											
										<Route path="/chats/" element={<ChatList nuovo={nuovoMessaggio}/> }/>
											
										<Route path="/notifications/" element={<Notifications nuovo={nuovoMessaggio}/> }/>
										
										<Route path="/find" element={<>
											{contextValue.flusso.messaggi_inviti ? (<Match/>) : (<><Find verified={true}/> 
											<PopupInfo/> </>)}
											
										</>}/>
										
										<Route path="/rate_plan" element={<>
										
										</>}/>
										
										
										<Route path="/user/:u" element={<>
											<Angel verifiedUser={verifiedUser}/>
										</>}/>
											
										<Route path="/profile" element={<>
											<Profilo/>
										</>}/>
											
										
										<Route path="/vip_plan/:rateplan" element={<>
											<PianiAbbonamento/>
										</>}/>
								
											
										<Route path="/purchase/pay" element={<>
											<PaymentPage/>
										</>}/>
											
										
										<Route path="/ok" element={<>
											<Ok/>
										</>}/>
											
									
										<Route path="/unsubscribe/" element={<>
											<Unsubscribe/>
										</>}/>

										<Route path="/ko" element={<>
											<Ko/>
										</>}/>

										<Route path="/trpay/paymentCheck" element={<>
											<Ok_trustPay/>
										</>}/>
										
										<Route path="/adyen/paymentCheck" element={<>
											<Check_payment_adyen/>
										</>}/>
										
										<Route path="/googlePay/paymentCheck" element={<>
											<Check_payment_googlePay/>
										</>}/>

										<Route path="/maxpay/paymentCheck" element={<>
											<Check_payment_maxpay/>
										</>}/>

										<Route path="/mollie/paymentCheck" element={<>
											<Check_payment_mollie/>
										</>}/>

										<Route path="/coda/paymentCheck" element={<>
											<Check_payment_coda/>
										</>}/>
										
										<Route path="/shift4/finalizePayment" element={<>
											<Finalize_payment_shift4/>
										</>}/>

										
											
										<Route path="/match" element={<>
											<Match/>
										</>}/>
										
										<Route path="/legal/:page" element={<>
											<Legal/>
										</>}/>
											
										<Route path="/contactUs" element={<>
											<ContactUs/>
										</>}/>
											
									
										<Route path="/activeNotifications" element={<>
											<PushTelegram/>
										</>}/>
											
									

										<Route path="/" element={<>
											<Navigate to="/find" />
										</>}/>

										<Route path="*" element={<>
											<Navigate to="/find" />
										</>}/>
											
										
									</Routes>
							
							</React.Fragment>
							)}
							
							{!verifiedUser && (
								<React.Fragment>
									<Routes>
										<Route path="*" element={<>
											<CatchAll onHide={() => {setModalShowHook(false); } } onShow={() => {setModalShowHook(true); } } verifiedUser={verifiedUser}/>
										</>}/>
									</Routes>
								</React.Fragment>
							)}
							
						
						<Footer/>
					</div>
				</Context.Provider>
				</GoogleOAuthProvider>
		</BrowserRouter>
	</ErrorBoundary>
	);
}